import { formatNumber } from "helpers/numbers";

export function formatMoney(num: string, currencySymbol: string) {
  if (num.trim().length === 0) {
    return '';
  }
  const sanitizedNumStr = num.replace(/\D/g, '');

  const numberValue = Number(sanitizedNumStr);

  let formattedNumber: string;

  if (numberValue >= 1e9) {
    formattedNumber = currencySymbol + (numberValue / 1e9).toFixed(1) + ' billion';
  } else if (numberValue >= 1e6) {
    formattedNumber = currencySymbol + (numberValue / 1e6).toFixed(1) + ' million';
  } else if (numberValue >= 1e3) {
    formattedNumber = currencySymbol + (numberValue / 1e3).toFixed(1) + ' thousand';
  } else {
    formattedNumber = currencySymbol + numberValue.toString();
  }

  if (formattedNumber.includes('.0')) {
    formattedNumber = formattedNumber.replace('.0', '');
  }

  return formattedNumber;
}

export const formatCurrency = (amount: number, currencySymbol: string) => `${currencySymbol}${formatNumber(amount)}`;
